



























































































































































import { Component, Ref } from 'vue-property-decorator'
import DropdownGroup from '@/components/common/DropdownGroup.vue'
import StickyButton from '@/components/common/StickyButton.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import RouterHelper from '@/mixins/RouterHelper.vue'
import { ElForm } from 'element-ui/types/form'
import {getResultList, resultPlot} from "@/request/apis/InferCNVRequest";
import {getSocket} from "@/socket.io";
import {getCirroUrl} from "@/request/apis/common";

@Component({
  components: {
    DropdownGroup,
    StickyButton,
    ResultWrapper,
    ModuleWrapper,
    ModuleIntroduction
  },
  beforeRouteUpdate (to, from, next) {
    next()
    // @ts-ignore
    this.getResult()
    // @ts-ignore
    this.getCirro()
  }
})
export default class InferCNVResult extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('dropdown') readonly dropdown!: DropdownGroup
  @Ref('iframe-wrapper') iframe!: HTMLElement

  private heatmapCellTypeUrl: string = ''
  private heatmapCNVUrl: string = ''
  private umapCNVUrl: string = ''
  private umapTraUrl: string = ''
  private heatmapTumorUrl: string = ''
  private heatmapNormalUrl: string = ''
  private umapUrl: string = ''
  private cirroUrl: string = ''
  private tumorGroupList: any[] = []
  private plotFigure: any = {
    tumorGroup: '',
    tumorIds: [],
    statusName: 'cnv_status',
  }
  private loadingProcessButton: boolean = false
  private tumorJson = {} as { [key: string]: string}

  get id () {
    return this.$route.params.id
  }

  get tumorIdsList () {
    this.plotFigure.tumorIds = []
    if (this.plotFigure.tumorGroup === 'None')
      return [this.tumorJson[this.plotFigure.tumorGroup]]
    else if (this.plotFigure.tumorGroup) {
      return this.tumorJson[this.plotFigure.tumorGroup]
    }
  }


  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            job_id: this.id,
            tumor_ids: this.plotFigure.tumorIds.toString(),
            tumor_group: this.plotFigure.tumorGroup,
            new_status_name: this.plotFigure.statusName
          }
          await resultPlot(null, params).start()
        } catch (e) {
          console.warn(e)
        }
      } else {
        return false
      }
    })
  }

  /**
   * 监听 websocket 消息
   */
  private async addSocketListener () {
    await this.$nextTick()
    const socket = getSocket()
    if (!socket) return
    socket.on('plot_finish', (res: any) => {
      const result = res.data
      if (result.job_id !== this.id) return // 如果更新的不是此任务就return
      this.loadingProcessButton = false
      this.dropdown.getDownloadData(this.id)
      if (result.status === 'error') {
        this.$notify.error({
          title: '提示',
          message: '更新失败',
          offset: 90,
          duration: 10000
        });
        return
      }
      // url相同时 img不更新, 拼接参数重新读取
      this.heatmapTumorUrl = InferCNVResult.timeStamp(result.heatmap_tumor_url)
      this.heatmapNormalUrl = InferCNVResult.timeStamp(result.heatmap_normal_url)
      this.umapUrl = InferCNVResult.timeStamp(result.umap_url)
      this.getCirro()
    })
  }

  private static timeStamp (str: string) {
    return str + '?' + (new Date()).getTime();
  }

  /**
   * 获取结果数据并显示
   */
  private async getResult () {
    const result = await getResultList(null, this.id).start()
    this.heatmapCNVUrl = result.heatmap_cnv
    this.heatmapCellTypeUrl = result.heatmap_celltype
    this.umapCNVUrl = result.umap_cnv
    this.umapTraUrl = result.umap_tra
    this.tumorJson = result.tumor_groups
    this.tumorGroupList = Object.keys(this.tumorJson)
  }

  /**
   * 获取cirro的链接，加载时loading
   */
  private async getCirro () {
    try {
      const getCirroRequest = getCirroUrl(this.iframe, { jobId: this.id, type: 'InferCNV' })
      this.cirroUrl = await getCirroRequest.start()
    } catch (e) {
      console.log(e)
    }
  }

  private get rules () {
    const checkStatusName = (rule: any, value: string, callback: Function) => {
      const pattern = /^[0-9A-Za-z_-]+$/
      if (!value || !pattern.test(value)) {
        callback(new Error(<string>this.$t('form.params.checkPattern')))
      }
      callback()
    }

    return {
      tumorGroup: [
        { required: true, message: new Error(<string>this.$t('form.params.checkParams')), trigger: 'blur' }
      ],
      tumorIds: [
        { required: true, message: new Error(<string>this.$t('form.params.checkParams')), trigger: 'blur' }
      ],
      statusName: [
        {validator: checkStatusName, trigger: 'change'}
      ]
    }
  }

  mounted () {
    this.getResult()
    this.addSocketListener()
  }

  destroyed () {
    const socket = getSocket()
    socket.off('plot_finish')
  }
}
